<template>
  <!-- Code here for the new image -->
  <v-stepper model-value="3" :vertical="$vuetify?.display?.xs" class="mb-16">
    <!-- Stepper Header for non-xs screens -->
    <v-stepper-header v-show="!$vuetify?.display?.xs">
      <v-stepper-item complete value="1" class="stepperTextSize">
        {{ $t('L_Submitted') }}
      </v-stepper-item>
      <v-divider />
      <v-stepper-item complete value="2" class="stepperTextSize">
        {{ $t('L_Received') }}
      </v-stepper-item>
      <v-divider />
      <v-stepper-item value="3" class="stepperTextSize">
        {{ $t('L_In_Review') }}
      </v-stepper-item>
    </v-stepper-header>

    <!-- Stepper Content -->
    <v-stepper-window>
      <!-- Step 1 -->
      <v-stepper-item
        complete
        value="1"
        v-show="$vuetify?.display?.xs"
        class="pl-0 pr-0 pt-0 my-step-complete"
      >
        {{ $t('L_Submitted') }}
      </v-stepper-item>
      <v-stepper-window-item value="1" class="pl-0 pr-0 pt-0"> </v-stepper-window-item>

      <!-- Step 2 -->
      <v-stepper-item
        v-if="$vuetify?.display?.xs"
        complete
        value="2"
        class="pl-0 pr-0 pt-0 my-step-complete"
      >
        {{ $t('L_Received') }}
      </v-stepper-item>
      <v-stepper-window-item value="2" class="pl-0 pr-0 pt-0"> </v-stepper-window-item>

      <!-- Step 3 -->
      <v-stepper-item
        v-show="$vuetify?.display?.xs"
        value="3"
        class="pl-0 pr-0 pt-0 my-step-complete"
      >
        {{ $t('L_In_Review') }}
      </v-stepper-item>
      <v-stepper-window-item value="3" class="pl-0 pr-0 pt-0"> </v-stepper-window-item>

      <div class="font-weight-bold mt-4 ml-4">
        {{ $t('L_terminated_your_policy_reinstament_request_is_currently_in_review') }}
      </div>
      <p class="mt-4 ml-4 pb-4 pr-4 font-size--14">
        <i18n-t keypath="L_terminated_please_allow_PLACEHOLDER" scope="global">
          <template #customerServicePhoneNum>
            {{ customerServicePhoneNum }}
          </template>
        </i18n-t>
      </p>
    </v-stepper-window>
  </v-stepper>
</template>

<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { $t } from '@/i18n/i18n.ts';

export default defineComponent({
  name: 'TerminatedProcessedForReinstatementContent',
  methods: { $t },
  computed: {
    ...mapStores(useGlobalStore),
    customerServicePhoneNum() {
      const locale = this.globalStore.getLocale.valueOf();
      switch (locale) {
        case 'en_US':
          return '(800) 257-4725';
        case 'en_CA':
          return '(800) 387-7876';
        case 'fr_CA':
          return '(800) 265-4804';
        default:
          return '(800) 257-4725';
      }
      return '(800) 257-4725';
    },
  },
});
</script>
